
import {defineComponent, PropType} from 'vue'
import ModalDialog from "../../components/ob1/ModalDialog.vue";
import AlertMessage from "../../components/ob1/AlertMessage.vue";

export default defineComponent({
    name: "CartPageSharing",
    components: {AlertMessage, ModalDialog},
    props: {
        cartDescription: {
          type: String,
          required: true
        },
        cartUrl: {
          type: String,
          required: true
        },
        iconFromSvg: {
          type: Boolean,
          required: true
        },
        authenticatedCartMessage: {
            type: String as PropType<string | null>,
            required: false,
            default: null
        }
    },
    data() {
        return {
            showShareOptions: false,
            isCopiedLink: false,
        }
    },
    mounted() {
        const modalElement = document.getElementById('social-share-modal');

        if (modalElement) {
            modalElement.addEventListener('show.bs.modal', this.resetCopiedState);
            modalElement.addEventListener('hidden.bs.modal', this.resetCopiedState);
        }
    },
    unmounted() {
        const modalElement = document.getElementById('social-share-modal');

        if (modalElement) {
            modalElement.removeEventListener('show.bs.modal', this.resetCopiedState);
            modalElement.removeEventListener('hidden.bs.modal', this.resetCopiedState);
        }
    },
    methods: {
        resetCopiedState() {
            this.isCopiedLink = false;
        },
        copyToClipboard(text: string) {
            navigator.clipboard.writeText(text).then(() => {
                this.isCopiedLink = true;
            });
        },
        shareOn(platform: string) {
            const url = encodeURIComponent(this.cartUrl);
            const title = encodeURIComponent(this.cartDescription);

            let shareUrl = '';
            switch (platform) {
                case 'facebook':
                    shareUrl = `https://www.facebook.com/dialog/send?link=${url}&app_id=YOUR_APP_ID&redirect_uri=${encodeURIComponent(window.location.origin)}`;
                    break;
                case 'twitter-x':
                    shareUrl = `https://twitter.com/intent/tweet?url=${url}&text=${title}`;
                    break;
                case 'whatsapp':
                    shareUrl = `https://wa.me/?text=${title}%20${url}`;
                    break;
                case 'email':
                    shareUrl = `mailto:?subject=Votre%20panier&body=${title}%20${url}`;
                    break;
            }

            if (shareUrl) {
                window.open(shareUrl, '_blank');
            }
        }
    }
})
